import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_0d21bf37";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_0d21bf37" };
/** script content **/
require("./input.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex0d21bf37%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Finput%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_0d21bf37"],
    ctorType: "component",
    outputPath: "components/index0d21bf37/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")), 'mpx-input': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
